import { FC } from "react";
import {
  getIconChannelUrl,
  toAbsoluteUrl,
} from "../../../../../../resources/helpers";

type Props = {
  channel?: string;
  accountName?: string;
};

const CIQChannelCell: FC<Props> = ({ channel, accountName }) => {
  if (!channel) {
    return <div className="text-gray-650">{channel}</div>;
  }

  return (
    <div className="d-flex align-items-center gap-2 w-fit">
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: 30,
          height: 30,
          minWidth: 30,
          minHeight: 30,
          overflow: "hidden",
          borderRadius: 6,
          backgroundColor: "#f0f0f0",
        }}
      >
        <img
          loading="lazy"
          src={toAbsoluteUrl(getIconChannelUrl(channel.toLowerCase()))}
          alt={channel}
          onError={(e) => {
            e.currentTarget.src = toAbsoluteUrl(
              "/media/images/dummy-image-square.jpg"
            );
          }}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "cover",
          }}
        />
      </div>
      <p
        className="m-0 p-0 text-nowrap text-truncate"
        style={{ maxWidth: 150 }}
      >
        {accountName || channel}
      </p>
    </div>
  );
};

export { CIQChannelCell };
